export default {
  welcome: 'Welcome',
  login: 'Log in',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm password',
  businessPortal: 'Business Portal',
  signInToYourAccount: 'Sign in to your account',
  privacyPolicy: 'Privacy Policy',
  termsOfUse: 'Terms of use',
  'Read our <1>Terms and Conditions</1> and <3>Privacy Policy</3>':
    'Read our <1>Terms and Conditions</1> and <3>Privacy Policy</3>',
  by: 'by',
  signUp: "Don't have an account yet? Sign up",
  'Forgot password?': 'Forgot password?',
  wrongPasswordOrEmail: 'Wrong password or email',
  reportsToWithoutTerminalErrorMessage:
    'We cannot link this team member to the one selected in the ‘Reports to’ field because the selected parent team member is not linked to any terminal. Please either assign a terminal to the parent team member first, or choose a different team member who is already linked to a terminal.',
  employeeWithoutTerminalErrorMessage:
    'We cannot link this team member to another using the ‘Reports to’ field because this team member is not linked to any terminal. Please assign a terminal to this team member first and try again.',
  employeeIsPartOfTheTreeTerminalErrorMessage:
    'We cannot unlink this team member from the terminal as this team member already included in the hierarchy (linked to another team member via the ‘Reports to’ field). To unlink the terminal, please first remove this team member’s hierarchical links.',
  country: 'Country',
  firstName: 'First name',
  lastName: 'Last name',
  phone: 'Phone',
  phoneNumber: 'Phone',
  continue: 'Continue',
  back: 'Back',
  companyLegalType: 'Company legal type',
  companyLegalName: 'Company legal name',
  document: 'Document',
  postalCode: 'Postal code',
  region: 'Region',
  city: 'City',
  address: 'Address',
  cityLocalized: 'City localized',
  addressLine: 'Address line',
  otpCode: 'One-time code',
  confirm: 'Confirm',
  cancel: 'Cancel',
  passwordsNotMatch: 'The two passwords that you entered do not match!',
  finish: 'Finish',
  add: 'Add',
  status: 'Status',
  table: 'Table',
  map: 'Map',
  cards: 'Cards',
  CURRENT_POSTED: 'Current balance',
  CURRENT_AVAILABLE: 'Available for payout',
  CURRENT_FLOAT_NAME: 'Current balance',
  CURRENT_PENDING: 'Sales volume',
  PROCESSED_IN_REALTIME: 'Processed in realtime',
  CURRENT_FLOAT: 'Float',
  documentType: 'Document type',
  number: 'Number',
  name: 'Name',
  CSV: 'CSV',
  XLSX: 'EXCEL',
  exportTo: 'Export to',
  processingCSV: 'Processing CSV...',
  processingXLSX: 'Processing XLSX...',
  confirmationExportTitle: 'Export limit: {{maxRecordsNumber}} records',
  confirmationExportBody:
    'You can export up to {{maxRecordsNumber}} records at a time. For faster results, narrow your filters. If the export reaches {{maxRecordsNumber}} records, it will stop and finalize automatically.',
  exportDone: 'Export ready',
  downloadWillStart: 'Your download will start automatically',
  exportDoneLimited: 'Export ready (limited to {{maxRecordsNumber}})',
  downloadWillStartLimited:
    'Only the first {{maxRecordsNumber}} records were exported. Your download will start automatically.',
  close: 'Close',
  amount: 'Amount',
  value: 'Value',
  currency: 'Currency',
  delete: 'Delete',
  yes: 'Yes',
  no: 'No',
  ID: 'ID',
  id: 'ID',
  logout: 'Logout',
  changePassword: 'Change password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  newPasswordAgain: 'New password again',
  passwordUpdated: 'Password updated!',
  language: 'Language',
  overview: 'All accounts totals',
  'View all accounts': 'View all accounts',
  required: 'Required',
  notEmail: 'This is not an Email',
  notDefined: 'Not defined',
  fullName: 'Full name',
  beneficiaries: 'Beneficiaries',
  you: 'you',
  columnChartTitle: 'Stores Sales Trend',
  topCountries: 'Top countries last 30 days',
  per: 'Per',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  Next: 'Next',
  Accept: 'Accept',
  // Sider menu
  dashboard: 'Dashboard',
  transactions: 'Transactions',
  payouts: 'Payouts',
  terminals: 'Terminals',
  team: 'Team',
  locations: 'Locations',
  qrCodes: 'QR codes',
  internetSales: 'Internet sales',
  accounts: 'Accounts',
  profile: 'Profile',
  payrolls: 'Payrolls',
  completeProfile: 'Complete profile',
  // Header
  mainSearchPlaceholder: 'Search transactions, invoices or help',
  save: 'Save',
  edit: 'Edit',
  // Days of week
  MO: 'Monday',
  TU: 'Tuesday',
  WE: 'Wednesday',
  TH: 'Thursday',
  FR: 'Friday',
  SA: 'Saturday',
  SU: 'Sunday',
  // messages
  dataUpdated: 'Data updated',
  areYouSure: 'Are you sure?',
  areYouSureYouWantTo: 'Are you sure you want to delete it?',
  deleteTeamMember: 'Delete team member {{name}} ',
  teamMemberHasAffiliationAlert: 'There are active affiliation links defined for this team member.',
  permissionDenied: 'Permission denied',
  permissionDeniedInfo: `User with role {{role}} hasn't permission for this page.`,
  permissionDeniedInfoMany: `User with roles {{role}} hasn't permission for this page.`,
  goBack: 'Go back',
  impossiblePhone:
    'Impossible phone number. Use international format: + (country code) phone number',
  invalidPhone: 'Invalid phone number. Use international format: + (country code) phone number',
  inputStringMin: 'Must be at least {{min}} characters',
  informationWillBeLost: 'Filled information will be lost!',
  rolesUpdated: 'Current logged user roles updated',
  somethingWentWrong: 'Something went wrong',
  deleting: 'Deleting...',
  deleted: 'Deleted!',
  updating: 'Updating...',
  updated: 'Updated!',
  creating: 'Creating...',
  created: 'Created!',
  regexValidationError: 'Invalid format. Use following pattern: {{pattern}}',
  'Your account is locked for {{duration}}': 'Your account is locked for {{duration}}',
  'There is no data to export': 'There is no data to export',
  wrongOtpCode: 'Authentication has failed. Wrong one-time code',
  wrongOtpCodeTooManyAttempts: 'Authentication has failed. Wrong one-time code. Too many attempts',
  // account autocomplete
  'Search by account number, account name or employee name':
    'Search by account number, account name or employee name',
  'Select account': 'Select account',
  'Select account by number': 'Select account by number',
  'Select account by linked employees': 'Select account by linked employees',
  textCopied: 'Text copied to clipboard!',
  copyToClipboard: 'Copy to clipboard',
  sendMoney: 'Send Money',
};
